/* ============================================================
   Testimonials Wall — "Worn in the Wild".
   Clicking a marquee card (or the prev/next arrows) features that
   review in the spotlight: quote, customer, stars, and the "They
   bought" product card all swap (with a wallIn animation). All data
   comes from a server-rendered JSON store (image URLs + money already
   formatted), so this script only swaps strings — it never touches
   Liquid and stays currency-agnostic. The marquee scroll + pause-on-
   hover are pure CSS, so they work even if this fails to load.
   ============================================================ */
(function () {
  var STAR = 'M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z';

  function starsHTML(rating) {
    var r = Math.round(rating) || 0, out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<svg class="wall__star' + (i <= r ? ' is-on' : '') + '" viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR + '"/></svg>';
    }
    return out;
  }

  function init(section) {
    if (section.__twInit) return;
    section.__twInit = true;

    var data = [];
    var dEl = section.querySelector('[data-tw-data]');
    if (dEl) { try { data = JSON.parse(dEl.textContent); } catch (e) { data = []; } }
    if (!data.length) return;

    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    var total = data.length;
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-tw-card]'));
    // Duplicate marquee cards stay clickable (a moving row may show either copy)
    // but are kept out of the tab order — the visible copy varies by scroll.
    section.querySelectorAll('.wall__group--dup [data-tw-card]').forEach(function (c) {
      c.setAttribute('tabindex', '-1');
    });

    // Spotlight refs (all null-safe — the spotlight can be disabled)
    var feature = section.querySelector('[data-tw-feature]');
    var swap = section.querySelector('[data-tw-swap]');
    var quoteEl = section.querySelector('[data-tw-quote]');
    var nameEl = section.querySelector('[data-tw-name]');
    var subEl = section.querySelector('[data-tw-sub]');
    var avatarEl = section.querySelector('[data-tw-avatar]');
    var starsEl = section.querySelector('[data-tw-stars]');
    var counterEl = section.querySelector('[data-tw-counter]');
    var buyBox = section.querySelector('[data-tw-buy]');
    var buyCards = Array.prototype.slice.call(section.querySelectorAll('[data-tw-buy-card]'));

    // Initial active = server-rendered .is-active card, else 0
    var active = 0;
    for (var n = 0; n < cards.length; n++) {
      if (cards[n].classList.contains('is-active')) {
        active = parseInt(cards[n].getAttribute('data-tw-card-id'), 10) || 0;
        break;
      }
    }

    function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }

    function fillSpotlight(i) {
      var d = data[i];
      if (!d) return;
      if (quoteEl) quoteEl.textContent = d.quote || '';
      if (nameEl) nameEl.textContent = d.author || '';
      if (subEl) { subEl.textContent = d.sub || ''; subEl.hidden = !d.sub; }
      if (avatarEl) {
        avatarEl.innerHTML = d.avatar
          ? '<img class="wall__avatar-img" src="' + d.avatar + '" alt="" loading="lazy">'
          : '<span class="wall__initials">' + (d.initials || '★') + '</span>';
      }
      if (starsEl) {
        starsEl.innerHTML = starsHTML(d.rating);
        starsEl.setAttribute('aria-label', 'Rating: ' + (Math.round(d.rating) || 0) + ' out of 5');
      }
      if (counterEl) counterEl.textContent = pad(i + 1);

      // "They bought" — reveal the pre-rendered real product card for this review,
      // hiding the column gracefully when the review has no product.
      if (buyBox) {
        var hasProduct = false;
        buyCards.forEach(function (c) {
          var on = parseInt(c.getAttribute('data-tw-buy-card'), 10) === i;
          c.hidden = !on;
          if (on) hasProduct = true;
        });
        buyBox.hidden = !hasProduct;
        if (feature) feature.classList.toggle('is-noproduct', !hasProduct);
      }

      // Replay the wallIn animation (transform-only; restart via forced reflow)
      if (swap && !reduce) { swap.style.animation = 'none'; void swap.offsetWidth; swap.style.animation = ''; }
    }

    function setActive(i) {
      active = i;
      cards.forEach(function (c) {
        c.classList.toggle('is-active', parseInt(c.getAttribute('data-tw-card-id'), 10) === i);
      });
      fillSpotlight(i);
    }

    function cycle(delta) { setActive((active + delta + total) % total); }

    section.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-tw-prev]');
      if (prev && section.contains(prev)) { cycle(-1); return; }
      var next = e.target.closest('[data-tw-next]');
      if (next && section.contains(next)) { cycle(1); return; }
      var card = e.target.closest('[data-tw-card]');
      if (card && section.contains(card)) {
        setActive(parseInt(card.getAttribute('data-tw-card-id'), 10) || 0);
      }
    });

    // Do NOT fill on load — the server already rendered the featured review (zero CLS).
  }

  function boot() { document.querySelectorAll('[data-tw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
